<div class="access-denied-container">
  <div class="access-denied-card">
    <div class="icon-circle">
      <span class="material-icons lock-icon">lock</span>
    </div>
    <h2>Access Denied</h2>
    <p class="desc">
      You don't have permission to access this tool. Please contact your Local Compliance Business Partner or your Line Manager
    </p>
  </div>
</div>
